module.exports = __webpack_public_path__ + "img/Silueta-Máscara.34879e62.png";